import m from 'mithril'

export default {
  view: vnode => {
    const zeusmodel = require('./zeusmodel.png')
    return (
      <div className={`log-book-page-content-inner log-book-page-template mod-21-page`}>
        <div className={`log-book-text-container ${vnode.attrs.unredacted ? 'is-unredacted' : 'is-redacted'}`}>

        <h3 className="log-book-text mod-h3">Amerikanske atomvåben i Grønland</h3> 

        <p className="log-book-text">I 1958: Fire atomflybomber placeret i Grønland i cirka 8 måneder. </p>

        <p className="log-book-text">Fra 1958: Overflyvning af Grønland med atombevæbnede B-52’ere.</p>

        <p className="log-book-text">Fra 1959: Nike- og Hercules-missiler til forsvaret af Thulebasen. </p>

        <p className="log-book-text">Fra 1959 er der også Nike-Hercules missiler i Danmark. Men de bærer ikke atomsprænghoveder, som de gør i Grønland. Det er den særlige Nike Zeus-model, der kan bære atomsprænghoveder. </p>
  
        <figure className="log-book-figure">
            <img src={zeusmodel} className="log-book-img" />       
            <figcaption className="log-book-figcaption">
                Her testes den i Californien i 1962. 
            </figcaption>     
          </figure>

        </div>
      </div>
    )
  }
}
